import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';
import { PurchaseMethodsV25, CurrencyFormats } from '@sm360/widget-commons-vehicle';
import 'payment-calculator-v25/components/TaxesIncluded/taxesIncluded.scss';

const TaxesIncluded = ({ purchaseMethods }) => {
    const { selectedPayment } = purchaseMethods.getCalculatorOptions() || {};
    const payment = selectedPayment?.payment ? (
        <PriceAmounts price={LocaleService.l(selectedPayment?.payment, CurrencyFormats.CURRENCY_2)} />
    ) : (
        ''
    );
    const paymentTaxes = selectedPayment?.paymentTaxes ? (
        <PriceAmounts price={LocaleService.l(selectedPayment?.paymentTaxes, CurrencyFormats.CURRENCY_2)} />
    ) : (
        ''
    );
    const taxesDetail = selectedPayment?.taxesDetail
        ? LocaleService.l(selectedPayment?.taxesDetail, CurrencyFormats.CURRENCY_2)
        : '';
    const totalPayment = selectedPayment?.totalPayment ? (
        <PriceAmounts price={LocaleService.l(selectedPayment?.totalPayment, CurrencyFormats.CURRENCY_2)} />
    ) : (
        ''
    );

    const paymentTaxesDisclaimer = (
        <>
            + {paymentTaxes} ({taxesDetail}) = {totalPayment}
        </>
    );

    return (
        <section className="taxesIncluded-section is-light">
            {payment && (
                <label htmlFor="taxesSlide" className="payment-detail is-light">
                    <span className="is-util">{payment}</span> <span>{paymentTaxesDisclaimer}</span>
                </label>
            )}
        </section>
    );
};

TaxesIncluded.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
};

TaxesIncluded.displayName = 'TaxesIncluded';

export default TaxesIncluded;
